import React from "react";
import NewCitizensComponent from "./NewCitizenComponent";

const NewCitizen = () => {
  return <NewCitizensComponent />;
};

export default NewCitizen;
